import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User, Company } from "@shared/types";

interface AuthState {
  user:
    | (Omit<User, "password_hash"> & {
        company_name?: string;
        company_slug?: string;
      })
    | null;
  token: string | null;
  company: Company | null;
  isAuthenticated: boolean;

  login: (user: any, token: string, company?: Company | null) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
  updateCompany: (company: Partial<Company>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      company: null,
      isAuthenticated: false,

      login: (user, token, company = null) => {
        set({
          user,
          token,
          company,
          isAuthenticated: true,
        });
      },

      logout: () => {
        set({
          user: null,
          token: null,
          company: null,
          isAuthenticated: false,
        });
      },

      updateUser: (userData) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        }));
      },

      updateCompany: (companyData) => {
        set((state) => ({
          company: state.company ? { ...state.company, ...companyData } : null,
        }));
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        company: state.company,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
